import React, { useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { FaWhatsapp, FaTimes, FaFilePdf } from "react-icons/fa";
import jsPDF from "jspdf";
import "./style.css";

const FloatingEnquireButton = () => {
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  // Hide on book-now page
  if (location.pathname === '/book-now') {
    return null;
  }

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const generatePDF = () => {
    setIsGeneratingPDF(true);
    
    // Small delay to show loading state
    setTimeout(() => {
      const doc = new jsPDF();
    
    // Set colors
    const primaryColor = [236, 51, 35]; // #ec3323
    const textColor = [51, 51, 51];
    
    // Add header with red background
    doc.setFillColor(...primaryColor);
    doc.rect(0, 0, 210, 40, 'F');
    
    // Company name
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(24);
    doc.setFont(undefined, 'bold');
    doc.text('SHER EAST AFRICA', 105, 20, { align: 'center' });
    
    doc.setFontSize(12);
    doc.setFont(undefined, 'normal');
    doc.text('Safari Vehicle Enquiry Form', 105, 30, { align: 'center' });
    
    // Reset text color
    doc.setTextColor(...textColor);
    
    // Add enquiry details
    let yPos = 55;
    
    doc.setFontSize(16);
    doc.setFont(undefined, 'bold');
    doc.setTextColor(...primaryColor);
    doc.text('Enquiry Details', 20, yPos);
    
    yPos += 10;
    
    // Draw a line
    doc.setDrawColor(...primaryColor);
    doc.setLineWidth(0.5);
    doc.line(20, yPos, 190, yPos);
    
    yPos += 15;
    doc.setTextColor(...textColor);
    doc.setFontSize(12);
    
    // Name
    doc.setFont(undefined, 'bold');
    doc.text('Name:', 20, yPos);
    doc.setFont(undefined, 'normal');
    doc.text(formData.name, 50, yPos);
    
    yPos += 15;
    
    // Email
    doc.setFont(undefined, 'bold');
    doc.text('Email:', 20, yPos);
    doc.setFont(undefined, 'normal');
    doc.text(formData.email, 50, yPos);
    
    yPos += 15;
    
    // Phone
    doc.setFont(undefined, 'bold');
    doc.text('Phone:', 20, yPos);
    doc.setFont(undefined, 'normal');
    doc.text(formData.phone, 50, yPos);
    
    yPos += 15;
    
    // Message
    doc.setFont(undefined, 'bold');
    doc.text('Message:', 20, yPos);
    doc.setFont(undefined, 'normal');
    const messageLines = doc.splitTextToSize(formData.message, 160);
    doc.text(messageLines, 20, yPos + 7);
    
    yPos += messageLines.length * 7 + 20;
    
    // Add timestamp
    doc.setDrawColor(...primaryColor);
    doc.line(20, yPos, 190, yPos);
    yPos += 10;
    
    doc.setFontSize(10);
    doc.setTextColor(128, 128, 128);
    doc.text(`Enquiry Date: ${new Date().toLocaleString('en-US', { timeZone: 'Africa/Nairobi', dateStyle: 'long', timeStyle: 'short' })}`, 20, yPos);
    doc.text('Source: Website Enquiry Form', 20, yPos + 7);
    
    // Add footer
    doc.setFontSize(9);
    doc.setTextColor(...primaryColor);
    doc.text('Sher East Africa Ltd | 44 Hanspaul Road, Njiro Industrial Area, Arusha, Tanzania', 105, 280, { align: 'center' });
    doc.text('Phone: +255 783 339 124 | Email: fleet@sher.co.tz', 105, 287, { align: 'center' });
    
    // Save the PDF
    const fileName = `Sher_Enquiry_${formData.name.replace(/\s+/g, '_')}_${new Date().getTime()}.pdf`;
    doc.save(fileName);
    
    setIsGeneratingPDF(false);
    }, 300); // Small delay to show loading state
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsGeneratingPDF(true);
    
    // Small delay to show loading state
    setTimeout(() => {
      // Format the message for WhatsApp with decorative elements
      const whatsappMessage = `
*Sher East Africa ENQUIRY*
━━━━━━━━━━━━━━━━━━━━

*Name:* ${formData.name}
*Email:* ${formData.email}
*Phone:* ${formData.phone}
*Message:* ${formData.message}

━━━━━━━━━━━━━━━━━━━━
*Time:* ${new Date().toLocaleString('en-US', { timeZone: 'Africa/Nairobi', dateStyle: 'medium', timeStyle: 'short' })}
*Source:* Website Enquiry
━━━━━━━━━━━━━━━━━━━━`; 
      
      // WhatsApp number (remove + and spaces)
      const whatsappNumber = "255783339124";
      
      // Open WhatsApp with pre-filled message - use encodeURIComponent for proper emoji encoding
      const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;
      window.open(whatsappUrl, "_blank");
      
      // Reset form and close modal
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
      
      setIsGeneratingPDF(false);
      handleClose();
    }, 300);
  };

  return (
    <>
      {/* Floating Button */}
      <div className="floating-enquire-button" onClick={handleShow}>
        <FaWhatsapp className="whatsapp-icon" />
        <span className="enquire-text">Enquire Now</span>
      </div>

      {/* Modal Form */}
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Title>Quick Enquiry</Modal.Title>
          <button className="close-btn" onClick={handleClose}>
            <FaTimes />
          </button>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Name *</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email *</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phone *</Form.Label>
              <Form.Control
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter your phone number"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Message *</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Tell us about your requirements"
                required
              />
            </Form.Group>

            <div className="d-grid gap-2">
              <Button 
                variant="danger" 
                type="submit" 
                className="whatsapp-submit-btn"
                disabled={isGeneratingPDF}
              >
                {isGeneratingPDF ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    {' '}Sending Enquiry...
                  </>
                ) : (
                  <>
                    Send Enquiry
                  </>
                )}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default FloatingEnquireButton;
